import React from 'react';
import { connect } from 'react-redux';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import CashFormatter from './cashFormatter';
import ReactDataGrid from 'react-data-grid';
import { isVAK } from '../../actions/root_url';
import { Row, Col, Button } from 'react-bootstrap';
class WeightChangeChooseProduct extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      salesOrderDetail: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
    }
  }

  componentDidMount() {
    if (this.props.salesOrderDetail) {
      this.initTableRows();
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.salesOrderDetail && nextProps.salesOrderDetail !== this.props.salesOrderDetail) {
      this.initTableRows();
    }
    if (nextProps.productRow && nextProps.productRow !== this.props.productRow) {

    }
  }

  initTableRows = () => {
    const {productRow: {Product_Details = '[]'} = {}} = this.props;
    const details = JSON.parse(Product_Details);
    const salesOrderDetail = {
      ...this.state.salesOrderDetail,
      rows: this.props.salesOrderDetail.Sales_Order_Lines.map(line => {
        const oldLine = details.find(oldLine => oldLine.SalesOrderLine_id === line.SalesOrderLine_id)
        return {
          ...line,
          isSelected: oldLine !== undefined,
          ShippedQuantity: oldLine ? oldLine.Quantity : 0,
        };
      }),
    };
    this.setState({ salesOrderDetail });
  }
  handleConfirm = () => {
    this.props.onConfirm && this.props.onConfirm(this.state.salesOrderDetail.selectedRows.filter(row => row.ShippedQuantity > 0))
  }

  renderTable = () => {
    const tableHeight = window.innerHeight < 930 ? 185 : 185;
    const getRows = () => Data.Selectors.getRows(this.state.salesOrderDetail);
    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.salesOrderDetail, {
        sortColumn,
        sortDirection,
      });
      this.setState({ salesOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const salesOrderDetail = { ...this.state.salesOrderDetail, filters: {} };
      this.setState({ salesOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.salesOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        filters: newFilters,
      };
      this.setState({ salesOrderDetail });
    };

    // Handle the row select function
    const onRowClick = (idx) => {
      const newRows = getRows();
      newRows[idx].isSelected = true;
      const selectedRows = newRows.filter(row => row.isSelected === true);
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrderDetail });
    }
    const onRowsSelected = rows => {
      const newRows = getRows();
      rows.forEach(row => {
        newRows[row.rowIdx].isSelected = true;
      });
      const selectedRows = newRows.filter(row => row.isSelected === true);
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrderDetail });
    };
    const onRowsDeselected = rows => {
      const newRows = getRows();
      rows.forEach(row => {
        newRows[row.rowIdx].isSelected = false;
      });
      const selectedRows = newRows.filter(row => row.isSelected === true);
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrderDetail });
    }
    const handleRowUpdated = e => {
      const newRows = getRows();
      newRows[e.rowIdx] = {...newRows[e.rowIdx], ...e.updated};
      const selectedRows = newRows.filter(row => row.isSelected === true);
      const salesOrderDetail = {
        ...this.state.salesOrderDetail,
        rows: newRows,
        selectedRows,
      };
      this.setState({ salesOrderDetail });
    }
    const columns = [
      {
        key: "RefNum",
        name: <Translate value="sku" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "Name",
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      },
      {
        key: "Description",
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: "Quantity",
        name: <Translate value="qty" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: "ShippedQuantity",
        name: <Translate value="shipped_qty" />,
        resizable: true,
        width: 100,
        sortable: true,
        editable: true,
      },
      {
        key: "UnitPrice",
        name: <Translate value="unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: "TotalPrice",
        name: <Translate value="total_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
    ]
    return <Row>
      <Col xs={12}>
        <ReactDataGrid
          enableCellSelect={true}
          rowKey="SalesOrderLine_id"
          onGridSort={handleGridSort}
          onAddFilter={handleFilterChange}
          onClearFilters={onClearFilters}
          columns={columns}
          rowGetter={rowGetter}
          rowsCount={getSize()}
          rowHeight={25}
          headerRowHeight={45}
          minHeight={tableHeight}
          onRowUpdated={handleRowUpdated}
          selectedRows={this.state.salesOrderDetail.selectedRows}
          enableRowSelect="single"
          onRowClick={onRowClick}
          rowSelection={{
            showCheckbox: true,
            enableShiftSelect: true,
            onRowsSelected,
            onRowsDeselected,
            selectBy: {
              isSelectedKey: "isSelected",
            },
          }}
        />
      </Col>
    </Row>
  }

  render() {
    return <div style={{width: 790}}>
      {this.renderTable()}
      <Row className="centerStyle" style={{ marginTop: '8px' }}>
        <Button
          style={{ marginRight: '5px' }}
          bsStyle="primary"
          onClick={this.handleConfirm}
        >
          <Translate value="confirm" />
        </Button>
      </Row>
    </div>
  }
}

const mapStateToProps = state => {
  return {
    salesOrderDetail: state.salesOrders.currentSalesOrderDetail,
  }
}
export default connect(mapStateToProps)(WeightChangeChooseProduct);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/weightChangeChooseProduct.jsx